//import disableScroll from "./disable-scroll";

let Helpers = {

    init(){
        
    },


};
export default Helpers;